<app-info-block [infoBlockConfig]="cidjBlockInfo" (tracker)="onTrackerCidjBlockClicked('Nouvelles Chances')">
  <p class="cidj-block__text">
    <span>Renseignez-vous sur les différents secteurs d&apos;activités et métiers avec le CIDJ.</span>
    <span class="line-break"
      >Vous y trouverez des fiches métiers par secteur, centre d&apos;intérêt et opportunités de recrutement afin
      d&apos;affiner vos choix d&apos;orientation.</span
    >
  </p>
</app-info-block>
